import {Elements} from '@stripe/react-stripe-js';
import React, {ReactNode, useMemo} from 'react';
import {loadStripeOnce} from "../../api/stripe.service";

const StripeWrapper = ({children}: {children: ReactNode}) => {
    const stripePromise = useMemo(loadStripeOnce, []);

    return <Elements stripe={stripePromise}>{children}</Elements>;
};

export default StripeWrapper;
